import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09a0a64d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ArticleSwitch" }
const _hoisted_2 = { class: "action-text tstn" }
const _hoisted_3 = { class: "article-title tstn" }
const _hoisted_4 = { class: "action-text tstn" }
const _hoisted_5 = { class: "article-title tstn" }
const _hoisted_6 = {
  key: 0,
  class: "ArticleSwitch-btn"
}

import { onMounted, reactive, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { getLastNext } from '@/apis/frog'
import { useRoute, useRouter } from 'vue-router'
import { useRtfix } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: {
  id: {
    type: Number,
    default: null
  },
  type: {
    type: Number,
    default: 3
  }
},
  setup(__props) {

const props = __props
const route = useRoute()
const router = useRouter()

const data: any = reactive({
  // 文章上一篇下一篇信息
  lastNextMsg: {}
})



onMounted(() => {
  getLastNextMsg()
})

// 监听id改变
watch(() => props.id, (val) => {
  getLastNextMsg()
})

// 获取当前文章的上一篇和下一篇信息
const getLastNextMsg = () => {
  const formData = {
    frogArticleId: props.id,
    type: props.type
  }
  getLastNext(formData).then((res: any) => {
    if (res.code === '0') {
      data.lastNextMsg = res.data
    }
  })
}

// 跳转文章详情
const toArticle = (id: string) => {
  // router.push(useRtfix('article', { params: { id, type: props.type } }))
}

// 切换文章
const articleSwitch = (id: string) => {
  const params: any = {
    ...route.params
  }
  params.id = id
  router.replace({ ...route, params })
}

// 跳转青蛙频道首页
const toKaerumedia = () => {
  // router.replace(useRtfix('kaerumedia'))
  router.go(-1)
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "ArticleSwitch-last",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (articleSwitch(_unref(data).lastNextMsg.prepArticleId)))
    }, [
      (_unref(data).lastNextMsg.prepArticleId)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('上一篇')), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).lastNextMsg.prepArticleTitle), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "ArticleSwitch-next",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (articleSwitch(_unref(data).lastNextMsg.nextArticleId)))
    }, [
      (_unref(data).lastNextMsg.nextArticleId)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('下一篇')), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(data).lastNextMsg.nextArticleTitle), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_unref(route).query.source !== 'shopcart')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            class: "btn",
            type: "primary",
            round: "",
            size: "large",
            onClick: toKaerumedia
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('返回')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})